import { TypeRole, TypeTitre } from 'core/models';
import { createContext, useContext, useState } from 'react';
import { TypeOptions } from 'react-toastify';

const UserInfosContext = createContext<any>({
    role: '',
    setRole: () => {},
    titre: '',
    setTitre: () => {},
    selectedResponsable: '',
    setSelectedResponsable: () => {},
    accesWeb: '',
    setAccesWeb: () => {},
    responsables: '',
    setResponsables: () => {},
    loading: false,
    setLoading: () => {},
});

interface Props {
    children: React.ReactNode;
}

export function UserInfosProvider({ children }: Props) {
    const [role, setRole] = useState<TypeRole>(TypeRole.UTILISATEUR);
    const [titre, setTitre] = useState<TypeTitre>(TypeTitre.MR);
    const [selectedResponsable, setSelectedResponsable] = useState<TypeOptions>();
    const [accesWeb, setAccesWeb] = useState(true);
    const [responsables, setResponsables] = useState([]);
    const [loading, setLoading] = useState(false);

    return (
        <UserInfosContext.Provider
            value={{
                role,
                setRole,
                titre,
                setTitre,
                selectedResponsable,
                setSelectedResponsable,
                accesWeb,
                setAccesWeb,
                responsables,
                setResponsables,
                loading,
                setLoading,
            }}
        >
            {children}
        </UserInfosContext.Provider>
    );
}

export const useUserInfosContext = () => useContext(UserInfosContext);
